<template>
    <h4 class="bg-success p-3 rounded text-white text-center fw-bold">{{$t("Father's Information")}}</h4>
    <div class="row mt-5">
        <div class="col-md-6">
            <b-form-group
                    id="father_name"
                    label-cols="3"
                    :label='$t("Father Name")'
                    label-for="father_name"
                    class="requiredField">
                <b-form-input
                        v-model="parentInfo.fatherName"
                        class="mb-3"
                        placeholder="Father's Name"
                        name="fatherName"
                        :state="getInputState(parentInfo.fatherName)">
                </b-form-input>
                <b-form-invalid-feedback v-if="showError(parentInfo?.fatherName)">
                    Father Name No is required.
                </b-form-invalid-feedback>
            </b-form-group>
        </div>
        <div class="col-md-6">
            <b-form-group
                    id="profession"
                    label-cols="3"
                    :label="$t('Profession')"
                    label-for="profession"
                    class="requiredField">
                <b-form-select
                        v-model="parentInfo.fatherProfessionId"
                        :options="professionOption" class="mb-3"

                        value-field="professionId"
                        text-field="profession"
                        disabled-field="notEnabled"
                        :state="getInputState(parentInfo.fatherProfessionId)">
                    <option value="" selected>-- Select Profession --</option>
                    <b-form-invalid-feedback v-if="showError(parentInfo.fatherProfessionId)">
                    Profession is required.
                </b-form-invalid-feedback>

                </b-form-select>
            </b-form-group>
        </div>
        <div class="col-md-6">
            <b-form-group
                    id="Nationality"
                    label-cols="3"
                    :label="$t('Nationality')"
                    label-for="nationality"
                    class="requiredField">
                <b-form-select
                        v-model="parentInfo.fatherNationalityId"
                        :options="nationalityOptions" class="mb-3"

                        value-field="countryId"
                        text-field="country"
                        disabled-field="notEnabled"
                        :state="getInputState(parentInfo.fatherNationalityId)">
                    <option value="" selected>-- Select Nationality --</option>
                    <b-form-invalid-feedback v-if="showError(parentInfo.fatherNationalityId)">
                        Father Name No is required.
                    </b-form-invalid-feedback>
                </b-form-select>
            </b-form-group>
        </div>
        <div class="col-md-6" v-if="parentInfo?.fatherNationalityId">
            <b-form-group
                    id="gender"
                    label-cols="3"
                    :label="$t('NID/Passport No')"
                    label-for="gender"
                    class="requiredField">
                <b-form-input
                        v-model="parentInfo.fatherNID"
                        type="text" class="form-control"
                        placeholder="NID / PASSPORT NO"
                        name="NID"
                        :state="getInputState(parentInfo.fatherNID)"></b-form-input>
                <b-form-invalid-feedback v-if="showError(parentInfo.fatherNID)">
                    Father NID is required.
                </b-form-invalid-feedback>
            </b-form-group>
        </div>
        <div class="col-md-6" v-if="parentInfo?.fatherNID">
            <b-form-group
                    :label="$t('NID/Passport Document')"
                    label-for="profile-photo"
                    class="profile-photo"
                    label-cols="3"
            >
                <div class="d-flex align-items-center">
                <input
                        type="file"
                        ref="fileinput"
                        name="profilePhoto"
                        @change="fatherNidAttach"
                        class="form-control form-control-md me-2"
                        style="width: 90%;"
                />
                    <button
                            class="btn btn-success"
                            @click="downloadFile(parentInfo.fatherNIDUrl, 'NID File')"
                            v-if="parentInfo.fatherNIDUrl"
                            style="white-space: nowrap;"
                    >
                        <font-awesome-icon class="text-white" :icon="['fas', 'download']"/>
                    </button>
                </div>
                <span style="font-size: 10px" class="text-danger">{{$t('Only PDF JPEG PNG')}}</span>
            </b-form-group>
        </div>
        <div class="col-md-6">
            <b-form-group
                    :label="$t('Father Existence Status')"
                    label-cols="3"
                    v-slot="{ ariaDescribedby }"
                    label-for="radios-btn-default">

                <b-form-radio-group
                        id="btn-radios-1"
                        v-model="parentInfo.fatherExisting"
                        :options="F_Existence_Status"
                        :aria-describedby="ariaDescribedby"
                        :button-variant="(parentInfo.fatherExisting=='false')?'outline-danger':'outline-success'"
                        name="father_existence_status*"
                        buttons
                ></b-form-radio-group>
            </b-form-group>
        </div>
        <div class="heading mb-4">
            <h4 class="bg-success p-3 rounded text-white text-center fw-bold">Mother's Information</h4>
        </div>

        <div class="col-md-6">
            <b-form-group
                    id="mother_name"
                    label-cols="3"
                    :label="$t('Mother Name')"
                    label-for="mother_name" class="requiredField">
                <b-form-input
                        type="text"
                        v-model="parentInfo.motherName"
                        class="form-control"
                        placeholder="Mother's Name"
                        :state="getInputState(parentInfo.motherName)"
                        name="mother_name"></b-form-input>
                <b-form-invalid-feedback v-if="showError(parentInfo.motherName)">
                    Mother Name is required.
                </b-form-invalid-feedback>
            </b-form-group>
        </div>
        <div class="col-md-6">
            <b-form-group
                    id="m_profession"
                    label-cols="3"
                    :label="$t('Profession')"
                    label-for="m_profession"
                    class="requiredField">
                <b-form-select
                        v-model="parentInfo.motherProfessionId"
                        :options="professionOption"
                        class="mb-3"
                        :state="getInputState(parentInfo.motherProfessionId)"
                        value-field="professionId"
                        text-field="profession"
                        disabled-field="notEnabled">
                    <option value="" selected>-- Select Profession --</option>
                    <b-form-invalid-feedback v-if="showError(parentInfo.motherProfessionId)">
                        Mother Profession is required.
                    </b-form-invalid-feedback>
                </b-form-select>
            </b-form-group>
        </div>
        <div class="col-md-6">
            <b-form-group
                    id="Nationality"
                    label-cols="3"
                    :label="$t('Nationality')"
                    label-for="nationality"
                    class="requiredField">
                <b-form-select
                        v-model="parentInfo.motherNationalityId"
                        :options="nationalityOptions"
                        class="mb-3"

                        value-field="countryId"
                        text-field="country"
                        disabled-field="notEnabled"
                        :state="getInputState(parentInfo.motherNationalityId)">
                    <option value="" selected>-- Select Nationality --</option>
                    <b-form-invalid-feedback v-if="showError(parentInfo.motherNationalityId)">
                        Mother Nationality is required.
                    </b-form-invalid-feedback>
                </b-form-select>
            </b-form-group>
        </div>
        <div class="col-md-6" v-if="parentInfo?.motherNationalityId">
            <b-form-group
                    id="gender"
                    label-cols="3"
                    :label="$t('NID/Passport No')"
                    label-for="gender"
                    class="requiredField">
                <b-form-input
                        type="text"
                        v-model="parentInfo.motherNID"
                        class="form-control" placeholder="NID / PASSPORT NO"
                        name="NID"
                        :state="getInputState(parentInfo.motherNID)">
                </b-form-input>
                <b-form-invalid-feedback v-if="showError(parentInfo.motherNID)">
                    Mother NID is required.
                </b-form-invalid-feedback>
            </b-form-group>
        </div>
        <div class="col-md-6" v-if="parentInfo?.motherNID">
            <b-form-group
                    :label="$t('NID/Passport Document')"
                    label-for="profile-photo"
                    class="profile-photo"
                    label-cols="3"
            >
                <div class="d-flex align-items-center">
                <input
                        type="file"
                        ref="fileinput"
                        name="profilePhoto"
                        @change="motherNidAttach"
                        class="form-control form-control-md me-2"
                        style="width: 90%;" />
                <button
                        class="btn btn-success"
                        @click="downloadFile(parentInfo.motherNIDUrl, 'NID File')"
                        v-if="parentInfo.motherNIDUrl"
                        style="white-space: nowrap;"
                >
                    <font-awesome-icon class="text-white" :icon="['fas', 'download']"/>
                </button>
        </div>
                <span style="font-size: 10px" class="text-danger">{{$t('Only PDF JPEG PNG')}}</span>
            </b-form-group>
        </div>
        <div class="col-md-6">
            <b-form-group
                    :label="$t('Mother Existence Status')"
                    label-cols="3"
                    v-slot="{ ariaDescribedby }"
                    label-for="radios-btn-default">
                <b-form-radio-group
                        id="btn-radios-2"
                        v-model="parentInfo.motherExisting"
                        :options="M_Existence_Status"
                        :aria-describedby="ariaDescribedby"
                        :button-variant="(parentInfo.motherExisting=='false')?'outline-danger':'outline-success'"
                        name="mother_existence_status*"
                        buttons
                ></b-form-radio-group>
            </b-form-group>
        </div>
    </div>
</template>
<script>
    import apiRepository, {getMedia} from '@/services/ApiRepository';
    import {toast} from 'vue3-toastify'

    export default {
        name: "Step-Three",
        props: ['formData'],
        components: {},
        data() {
            return {
                professionOption: [],
                nationalityOptions: [],
                parentInfo: {
                    ...this.formData,
                    fatherExisting: 'true',
                    motherExisting: 'true',
                    motherNIDFile: null,
                    fatherNIDFile: null,
                    fatherName:'',
                    fatherNID:'',
                    fatherNationalityId:'',
                    motherName:'',
                    motherNID:'',
                    motherNationalityId:'',
                },
                F_Existence_Status: [
                    {text: this.$t('Alive'), value: 'true'},
                    {text: this.$t('Dead'), value: 'false'},
                ],
                M_Existence_Status: [
                    {text: this.$t('Alive'), value: 'true'},
                    {text: this.$t('Dead'), value: 'false'},
                ]
            }
        },
        mounted() {
            this.countryData();
            this.professionData();
            this.fetchProfileData()

        },
        watch: {
            parentInfo: {
                deep: true,
                handler(newVal) {
                    this.$emit("update:formData", newVal);
                }
            }
        },
        methods: {
            fetchProfileData() {
                try {
                    apiRepository.userDataGet().then((response) => {
                        if (response) {
                            console.log('datatat', response.data)
                            this.parentInfo = response.data.parentInfo || this.parentInfo;
                        } else {
                            console.error('Data not Found!!')
                        }
                    })
                } catch (e) {
                    toast.error('Invalid Request !', e)
                }

            },
            getInputState(value) {
                if (value === '') return false;
                if (typeof value === 'string') return value.trim().length > 0;
                return !!value;
            },
            showError(value) {
                return value === '' || (typeof value === 'string' && value.trim() === '');
            },
            countryData() {
                apiRepository.getCountry().then((response) => {
                    if (response || response.data || response.data.data) {
                        this.nationalityOptions = response.data;
                    }
                })
            },
            professionData() {
                apiRepository.getProfession().then((response) => {
                    if (response || response.data || response.data.data) {
                        this.professionOption = response.data;
                    } else {
                        console.error('Invalid response structure:', response.data);
                    }
                })
                    .catch((error) => {
                        console.error('Error fetching profession data:', error);
                    });
            },
            fatherNidAttach(event) {
                const file = event.target.files[0];

                if (file) {
                    let reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                        this.parentInfo.fatherNIDFile = reader.result;
                    };
                }
            },
            motherNidAttach(event) {
                const file = event.target.files[0];

                if (file) {
                    let reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                        this.parentInfo.motherNIDFile = reader.result;
                    };
                }
            },
            async downloadFile(url, filename) {
                // Normalize some MIME subtype extensions (optional)
                const specialMimeExtMap = {
                    jpeg: "jpg",
                    msword: "doc",
                    "vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
                    "vnd.ms-excel": "xls",
                    "vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
                    "vnd.ms-powerpoint": "ppt",
                    "vnd.openxmlformats-officedocument.presentationml.presentation": "pptx",
                    "x-7z-compressed": "7z"
                    // Add more if needed
                };

                try {
                    const response = await fetch(getMedia() + url);
                    if (!response.ok) {
                        throw new Error(`Failed to fetch file: ${response.status} ${response.statusText}`);
                    }

                    const data = await response.json();

                    // Decode base64 content
                    const byteCharacters = atob(data.content);
                    const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0));
                    const byteArray = new Uint8Array(byteNumbers);

                    // Determine correct content type
                    let contentType = data.contentType || "";
                    let fileExt = "";

                    if (contentType.includes('/')) {
                        // Extract subtype after '/'
                        fileExt = contentType.split('/')[1].split(';')[0].trim().toLowerCase();

                        // Normalize extension if needed
                        if (fileExt in specialMimeExtMap) {
                            fileExt = specialMimeExtMap[fileExt];
                        }
                    }

                    // If filename doesn't already end with this extension, append it
                    if (fileExt && !filename.toLowerCase().endsWith(`.${fileExt}`)) {
                        filename += `.${fileExt}`;
                    }

                    // Create Blob
                    const blob = new Blob([byteArray], { type: contentType || "application/octet-stream" });

                    // Trigger download
                    const blobUrl = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = blobUrl;
                    link.download = filename;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(blobUrl);

                } catch (error) {
                    console.error("Download failed:", error);
                }
            },
        }

    }
</script>

<style scoped></style>